
import { CheckCircle, Shield, Zap, Clock } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    icon: <Shield className="w-6 h-6" />,
    title: "Vetted PEO Partners",
    description: "Access our network of thoroughly vetted and trusted PEO providers."
  },
  {
    icon: <Zap className="w-6 h-6" />,
    title: "Smart Matching",
    description: "Get matched with the perfect PEO partner based on your specific needs."
  },
  {
    icon: <Clock className="w-6 h-6" />,
    title: "Quick Process",
    description: "Complete your application in minutes and receive personalized quotes."
  },
  {
    icon: <CheckCircle className="w-6 h-6" />,
    title: "Expert Guidance",
    description: "Receive support from our team throughout your PEO selection journey."
  }
];

export const FeaturesSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-background to-primary/5">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="glass-card p-6 rounded-xl border border-primary/10 hover:border-primary/20 transition-all duration-300 group"
              >
                <div className="bg-primary/10 p-3 rounded-lg w-12 h-12 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 text-primary">
                  {feature.icon}
                </div>
                <h3 className="text-lg font-semibold mb-2 text-foreground">{feature.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
